<div>
  <form [formGroup]="form">
    <ion-row class="scheduling">
      <ion-col size="12">
        <ion-row>
          <ion-col size="12" class="section-header">
            {{ SCHEDULING_CONSTANTS.HEADER }}
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col size="9">
            <!-- ===================== ROW 1 ===================== -->
            <ion-row>
              <ion-col size="4">
                <app-read-only-fields
                  [labelText]="SCHEDULING_CONSTANTS.REQUEST_NUMBER"
                  [fieldText]="data.requestShipperNo"
                ></app-read-only-fields>
              </ion-col>

              <ion-col size="4">
                <app-read-only-fields
                  [labelText]="SCHEDULING_CONSTANTS.ORDER_TYPE"
                  [fieldText]="data.orderType"
                ></app-read-only-fields>
              </ion-col>

              <ion-col size="4">
                <app-read-only-fields
                  [labelText]="SCHEDULING_CONSTANTS.PICK_UP_AMT"
                  [fieldText]="data.shipPUCharge ?? '-'"
                ></app-read-only-fields>
              </ion-col>
            </ion-row>

            <!-- ===================== ROW 2 ===================== -->
            <ion-row>
              <ion-col size="4">
                <app-read-only-fields
                  [labelText]="SCHEDULING_CONSTANTS.ORDER_DATE"
                  [fieldText]="convertedOrderDate ?? '-'"
                ></app-read-only-fields>
              </ion-col>

              <ion-col size="4">
                <app-read-only-fields
                  [labelText]="SCHEDULING_CONSTANTS.SERVICE_CENTER_SLIC"
                  [fieldText]="data.serviceCenter ?? '-'"
                ></app-read-only-fields>
              </ion-col>

              <ion-col size="4">
                <app-read-only-fields
                  [labelText]="SCHEDULING_CONSTANTS.CSTC_SITE_NAME"
                  [fieldText]="data.cstcSiteName ?? '-'"
                ></app-read-only-fields>
              </ion-col>
            </ion-row>

            <!-- ===================== ROW 3 ===================== -->
            <ion-row>
              <ion-col size="4">
                <app-read-only-fields
                  [labelText]="SCHEDULING_CONSTANTS.SERVICE_DATE"
                  [fieldText]="convertedServiceDate ?? '-'"
                ></app-read-only-fields>
              </ion-col>

              <ion-col size="4">
                <app-read-only-fields
                  [labelText]="SCHEDULING_CONSTANTS.PREFERRED_CUSTOMER"
                  [fieldText]="data.preferredCustomer ?? '-'"
                ></app-read-only-fields>
              </ion-col>

              <ion-col size="4">
                <app-read-only-fields
                  [labelText]="SCHEDULING_CONSTANTS.CSTC_OPERATOR"
                  [fieldText]="data.cstcOperator ?? '-'"
                ></app-read-only-fields>
              </ion-col>
            </ion-row>

            <!-- ===================== ROW 4 ===================== -->
            <ion-row>
              <!-- Service Type -->
              <ion-col size="4">
                <app-read-only-fields
                  [labelText]="SCHEDULING_CONSTANTS.SERVICE_TYPE"
                  [fieldText]="data.serviceType ?? '-'"
                ></app-read-only-fields>
              </ion-col>

              <ion-col size="4">
                <app-read-only-fields
                  [labelText]="SCHEDULING_CONSTANTS.PACKAGE_TYPE"
                  [fieldText]="data.packageType ?? '-'"
                ></app-read-only-fields>
              </ion-col>

              <ion-col size="4">
                <app-read-only-fields
                  [labelText]="SCHEDULING_CONSTANTS.CSTC_SITE_PHONE"
                  [fieldText]="data.cstcSitePhone ?? '-'"
                ></app-read-only-fields>
              </ion-col>
            </ion-row>

            <!-- ===================== ROW 5 ===================== -->
            <ion-row>
              <!-- Shipper Number -->
              <ion-col size="4">
                <app-read-only-fields
                  [labelText]="SCHEDULING_CONSTANTS.SHIPPER_NUMBER"
                  [fieldText]="data.shipperNumber"
                ></app-read-only-fields>
              </ion-col>

              <ion-col size="4">
                <app-read-only-fields
                  [labelText]="SCHEDULING_CONSTANTS.PACKAGE_WEIGHT"
                  [fieldText]="data.packageWeight ?? '-'"
                ></app-read-only-fields>
              </ion-col>

              <ion-col size="4">
                <app-read-only-fields
                  [labelText]="SCHEDULING_CONSTANTS.VAT_PORTION"
                  [fieldText]="data.vatPortion ?? '-'"
                ></app-read-only-fields>
              </ion-col>
            </ion-row>

            <!-- ===================== ROW 6 ===================== -->
            <ion-row>
              <!-- Pickup Number -->
              <ion-col size="4">
                <app-read-only-fields
                  [labelText]="SCHEDULING_CONSTANTS.PICKUP_NUMBER"
                  [fieldText]="data.pickupNumber ?? '-'"
                ></app-read-only-fields>
              </ion-col>

              <ion-col size="4">
                <app-read-only-fields
                  [labelText]="SCHEDULING_CONSTANTS.OVER_WEIGHT"
                  [fieldText]="data.overWeight ?? '-'"
                ></app-read-only-fields>
              </ion-col>

              <ion-col size="4">
                <app-read-only-fields
                  [labelText]="SCHEDULING_CONSTANTS.DRIVER_INSTRUCTIONS"
                  [fieldText]="data.driverInstructions ?? '-'"
                ></app-read-only-fields>
              </ion-col>
            </ion-row>
          </ion-col>

          <!-- ===================== COLUMN 4 (Right Panel) ===================== -->
          <ion-col size="3">
            <ion-row>
              <div class="form-group">
                <label [for]="CONTROLS.READY_TIME"
                  >{{ SCHEDULING_CONSTANTS.READY_TIME }}
                </label>
                <app-form-time-picker
                  [defaultStartTime]="form.get(CONTROLS.READY_TIME)?.value"
                  [form]="form"
                  [control]="CONTROLS.READY_TIME"
                  [required]="false"
                ></app-form-time-picker>
              </div>
            </ion-row>

            <ion-row>
              <div class="form-group">
                <label [for]="CONTROLS.COMMIT_TIME">
                  {{ SCHEDULING_CONSTANTS.COMMIT_TIME }}
                </label>
                <app-form-time-picker
                  [defaultStartTime]="form.get(CONTROLS.COMMIT_TIME)?.value"
                  [form]="form"
                  [control]="CONTROLS.COMMIT_TIME"
                  [required]="false"
                ></app-form-time-picker>
              </div>
            </ion-row>

            <ion-row>
              <div class="form-group">
                <label [for]="CONTROLS.CLOSING_TIME">
                  {{ SCHEDULING_CONSTANTS.CLOSING_TIME }}
                </label>
                <app-form-time-picker
                  [defaultStartTime]="form.get(CONTROLS.CLOSING_TIME)?.value"
                  [form]="form"
                  [control]="CONTROLS.CLOSING_TIME"
                  [required]="false"
                ></app-form-time-picker>
              </div>
            </ion-row>
          </ion-col>
        </ion-row>
      </ion-col>
    </ion-row>
  </form>
</div>
